import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsCoreAgentsRoute: InvariantJiraRoute = {
	name: 'project-settings-core-agents',
	path: '/jira/core/projects/:projectKey/settings/agents',
	exact: true,
};
